import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Label, Input, CustomCheckbox } from './style';
import HtmlRaw from '../HtmlRaw';

const Checkbox = ({
  label,
  name,
  onChange,
  checked,
  value: eValue,
  disabled,
  classes,
  hiddenLabel,
  required,
}) => {
  const [value, setValue] = useState(eValue);
  const handleOnChange = ({ currentTarget: { value: newValue } = {} }) => {
    setValue(newValue);
    if (onChange) onChange(newValue);
  };
  return (
    <Label
      disabled={disabled}
      className={classes}
      data-checked={checked}
      hiddenLabel={hiddenLabel}
    >
      <HtmlRaw
        html={label || ''}
        className={`${required ? 'required' : ''} ${hiddenLabel ? 'visually-hidden' : ''}`}
      />
      <Input
        checked={checked}
        type="checkbox"
        name={name ? `checkbox-${name}` : null}
        value={value}
        onChange={handleOnChange}
        disabled={disabled}
      />
      <CustomCheckbox hiddenLabel={hiddenLabel} />
    </Label>
  );
};

Checkbox.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  classes: PropTypes.string,
  hiddenLabel: PropTypes.bool,
  required: PropTypes.bool,
};

export default Checkbox;
